import React from 'react';

import {Anchor, Button} from '@newsela/angelou';
import {cx} from 'emotion';
import PropTypes from 'prop-types';

import withTrackEvent from 'static/three-oh/src/components/with/WithTrackEvent';

import {ReactComponent as GoogleSvg} from '../assets/GoogleSSO.svg';
import styles from '../styles';

const propTypes = {
  actionName: PropTypes.string,
  additionalClassName: PropTypes.string,
  anchorText: PropTypes.string.isRequired,
  ariaProps: PropTypes.object,
  href: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  eventProperties: PropTypes.object,
  legacyEventName: PropTypes.string,
  streamProperties: PropTypes.object,
};


const AnchorWithTrackEvent = withTrackEvent(Anchor);

const GoogleAnchor = ({
  actionName,
  additionalClassName,
  anchorText,
  ariaProps,
  href,
  iconClassName,
  eventProperties,
  legacyEventName,
  streamProperties,
}) => {
  return (
    <AnchorWithTrackEvent
      actionName={actionName}
      additionalClassName={additionalClassName}
      ariaProps={ariaProps}
      __css={`
      background-color: ${styles.white};
      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.24);
      padding-left: 0rem;
      &:hover, &:focus {
        background: linear-gradient(0deg, rgba(29, 29, 29, 0.15), rgba(29, 29, 29, 0.15)), ${styles.white};
      }
      &[disabled] {
        background-color: ${styles.white};
      }
      `}
      dataProps={{
        'data-qa-selector': 'google_link',
        id: 'google_link'
      }}
      eventProperties={eventProperties}
      href={href}
      legacyEventName={legacyEventName}
      objectType="User"
      streamProperties={streamProperties}
      styleAnchorAsButton={{
        flavor: Button.flavor.solid,
        statusColor: Button.statusColor.primary,
        size: Button.size.justified
      }}
    >
      <div className={styles.socialLinkDescription}>
        <GoogleSvg
          aria-hidden="true"
          className={cx([styles.googleIcon, iconClassName])}
        />
        <span className={styles.googleLabel}>{anchorText}</span>
      </div>
    </AnchorWithTrackEvent>
  );
};

GoogleAnchor.propTypes = propTypes;

export default GoogleAnchor;
